/**
 * Payment-related constants
 *
 * These are identifiers, not secrets, so it's safe to hardcode them.
 * They automatically switch based on environment (production vs development).
 *
 * Note: We use process.env.NODE_ENV instead of VERCEL_ENV because this
 * constant is used on the client side and VERCEL_ENV is server-only.
 */

const IS_PROD = process.env.NODE_ENV === "production";

/**
 * PayPal Custom Payment Method ID
 *
 * This ID is created in Stripe Dashboard under:
 * Settings > Payments > Custom Payment Methods
 *
 * You need separate IDs for test and production environments.
 */
export const PAYPAL_CUSTOM_PAYMENT_METHOD_ID = IS_PROD
  ? "cpmt_1SFYzEDDoy5TSXF0gtj9H5CF" // Production
  : "cpmt_1SGwtbDDoy5TSXF0LHwY3C3z"; // Test/Development
